export default __webpack_public_path__ + "static/media/c7.16e7810b.png";